import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

import "@/assets/styles/main.scss";

import ClickOutside from "click-outside-vue3";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    BarElement,
    Legend,
} from "chart.js";

import AnnotationPlugin from "chartjs-plugin-annotation";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    BarElement,
    Legend,
    AnnotationPlugin
);

const app = createApp(App).use(store).use(router).use(i18n).use(ClickOutside);

router.isReady().then(() => {
    app.mount("#app");
});
